import { useState, useEffect, useRef } from 'react';
import Logo from '../logo.png';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      if (currentY < 10) {
        // Always show at the very top
        setVisible(true);
      } else if (currentY < lastScrollY.current) {
        // Scrolling up — show
        setVisible(true);
      } else {
        // Scrolling down — hide
        setVisible(false);
        setMenuOpen(false);
      }
      lastScrollY.current = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className={`Navbar ${visible ? 'navbar--visible' : 'navbar--hidden'}`}>
        <div className='Navbar-container'>
            <div className='header-logo'>
                <img 
                    src={Logo} 
                    alt='RastegHub Logo' 
                    className='logo'
                />
            </div>

            <div className={`navitems ${menuOpen ? 'open' : ''}`}>
                <a className="navitem" href='#home' onClick={closeMenu}>Home</a>
                <a className="navitem" href='#about' onClick={closeMenu}>About</a>
                <a className="navitem" href='#services' onClick={closeMenu}>Services</a>
                <a className="navitem" href='#products' onClick={closeMenu}>Products</a>
                <a className="navitem" href='#contact' onClick={closeMenu}>Contact</a>
                <div className='nav-cta nav-cta--mobile'>
                    <a href='/quote' className='nav-btn' onClick={closeMenu}>Get Quote</a>
                </div>
            </div>

            <div className='nav-cta nav-cta--desktop'>
                <a href='/quote' className='nav-btn'>Get Quote</a>
            </div>

            <button
                className={`hamburger ${menuOpen ? 'active' : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
                aria-expanded={menuOpen}
            >
                <span className='bar'></span>
                <span className='bar'></span>
                <span className='bar'></span>
            </button>
        </div>

        {/* Overlay to close menu when clicking outside */}
        {menuOpen && <div className='nav-overlay' onClick={closeMenu}></div>}
    </div>
  )
}

export default Navbar;